import React from "react";
import Enterprise from "../assest/Icon/office-building.png";
import maintenance from "../assest/Icon/maintenance-service.png";
import { BsRocketTakeoff } from "react-icons/bs";
import "./Solutions.css";
import { useLanguage } from "../components/LanguageContext";
import { IoMdCloudOutline } from "react-icons/io";

const Solutions = () => {
  const { language } = useLanguage();
  return (
    <section className="solutions">
      <div className="intro">
        <h1>{language === "en" ? "About Proscope" : "เกี่ยวกับ Proscope"}</h1>
        <br></br>
        <p>
          {language === "en" ? (
            <>
              Proscope has been proudly serving businesses in Thailand since
              2013. We began with a strong foundation in designing
              infrastructure, networks, and data center security—backed by deep
              technical expertise and a passion for solving complex IT
              challenges.
              <br />
              <br />
              Our approach is customer-first. We take time to understand your
              unique requirements and offer tailored consulting, best-practice
              implementation, and a range of technology options—empowering you
              to make informed decisions that meet your specific business needs.
              <br />
              <br />
              To ensure the highest level of service, we carefully select our
              team and continuously invest in their development. Our engineers
              are encouraged to pursue industry-leading certifications and stay
              ahead of emerging technologies. Today, our team holds a wide range
              of certifications across virtualization, backup, networking,
              cybersecurity, and software development.
              <br />
              <br />
              We believe in building strong partnerships. That means working
              closely with our clients, providing hands-on support when
              challenges arise, and nurturing long-term relationships based on
              trust, speed, and consistent value.
              <br />
              <br />
              With long-standing alliances with global hardware and software
              vendors, combined with over a decade of proven experience, we’re
              able to respond quickly—delivering expert advice during the
              pre-sale phase and reliable technical support post-sale.
            </>
          ) : (
            <>
              Proscope เริ่มดำเนินธุรกิจในประเทศไทยตั้งแต่ปี พ.ศ. 2556
              โดยมีความเชี่ยวชาญด้านการออกแบบโครงสร้างพื้นฐานระบบ IT เครือข่าย
              และระบบความปลอดภัยในศูนย์ข้อมูล (Data Center)
              เรามุ่งมั่นในการให้บริการที่ตอบโจทย์ความต้องการของลูกค้าอย่างแท้จริง
              <br />
              <br />
              เรายึดหลัก “ลูกค้าเป็นศูนย์กลาง” โดยให้คำปรึกษาอย่างตรงจุด
              ออกแบบโซลูชันตามแนวทางปฏิบัติที่ดีที่สุด
              พร้อมนำเสนอทางเลือกที่เหมาะสม
              เพื่อให้ลูกค้าสามารถตัดสินใจได้อย่างมั่นใจและตอบโจทย์ธุรกิจของตนเองอย่างแท้จริง
              <br />
              <br />
              เราคัดเลือกทีมงานอย่างพิถีพิถัน
              และสนับสนุนให้พัฒนาความรู้ความสามารถอย่างต่อเนื่อง
              ไม่ว่าจะเป็นการอบรม หรือการสอบใบรับรองวิชาชีพจากสถาบันระดับโลก
              ปัจจุบันทีมงานของเรามีใบรับรองในหลากหลายด้าน ทั้งระบบเสมือนจริง
              (Virtualization), การสำรองข้อมูล, ระบบเครือข่าย,
              ความปลอดภัยทางไซเบอร์ และการพัฒนาโปรแกรม
              <br />
              <br />
              Proscope เชื่อมั่นในความสัมพันธ์ระยะยาวกับลูกค้า
              เราทำงานเคียงข้างคุณอย่างใกล้ชิด
              พร้อมเข้าช่วยเหลือทันทีเมื่อเกิดปัญหา
              และสร้างความไว้วางใจในระยะยาว
              <br />
              <br />
              ด้วยประสบการณ์มากกว่าทศวรรษ
              และความร่วมมืออย่างแน่นแฟ้นกับพันธมิตรด้านฮาร์ดแวร์และซอฟต์แวร์ระดับโลก
              เราจึงสามารถตอบสนองได้อย่างรวดเร็ว ทั้งในขั้นตอนก่อนการขาย
              และการสนับสนุนหลังการขาย
            </>
          )}
        </p>
        <br />
        <p className="highlight">
          <strong>
            {language === "en"
              ? "Let Proscope be your trusted partner in building an agile, secure, and future-ready IT foundation."
              : "ให้ Proscope เป็นพาร์ตเนอร์ที่คุณไว้วางใจ ในการสร้างระบบ IT ที่ยืดหยุ่น ปลอดภัย และพร้อมรับอนาคต"}
          </strong>
        </p>

        <br></br>

        <br></br>
        <h1>Our Core business Pillars</h1>
        <br />
        <p className="highlight">
          <strong>
            {language === "en"
              ? "Our four business pillars are Enterprise Solution, Cloud Solution, Value-Added Distributor, and Maintenance Services."
              : "ธุรกิจของ Proscope ขับเคลื่อนด้วย 3 เสาหลักสำคัญ ได้แก่ โซลูชันคลาวด์ โซลูชันสำหรับองค์กร และการเป็นตัวแทนจำหน่าย"}
          </strong>
        </p>
        <br></br>
      </div>

      <div className="solution-card">
        <div className="icon-container">
          <img src={Enterprise} alt="Cloud Icon" className="icon" />
        </div>
        <h3>
          {language === "en"
            ? "Enterprise Solution"
            : "โซลูชันสำหรับองค์กร (Enterprise Solution)"}
        </h3>
        <p>
          {language === "en" ? (
            <>
              As a comprehensive IT solution provider, Proscope partners with
              leading hardware and software vendors to deliver full-cycle
              services—from consulting and planning to deployment and ongoing
              support.
              <br />
              <br />
              We help organizations design and implement secure network
              infrastructure, scalable data centers, endpoint solutions, and
              custom enterprise software. Our team works hand-in-hand with
              clients to deliver reliable systems aligned with business goals.
              With certified experts and industry best practices, we provide
              end-to-end IT solutions that empower long-term success across all
              sectors.
            </>
          ) : (
            <>
              Proscope ให้บริการโซลูชันแบบครบวงจร
              โดยร่วมมือกับพันธมิตรด้านฮาร์ดแวร์และซอฟต์แวร์ชั้นนำ
              เพื่อส่งมอบบริการตั้งแต่การวางแผน ออกแบบ ติดตั้ง
              ไปจนถึงการดูแลหลังการขายอย่างมืออาชีพ
              <br />
              <br />
              เราช่วยองค์กรออกแบบระบบเครือข่าย ศูนย์ข้อมูล ระบบความปลอดภัย
              ซอฟต์แวร์เฉพาะทาง และอุปกรณ์ปลายทางต่าง ๆ
              ทีมงานของเราทำงานใกล้ชิดกับลูกค้าเพื่อให้ได้ระบบที่เสถียร ตอบโจทย์
              และมีประสิทธิภาพสูงสุด พร้อมผลักดันความสำเร็จในระยะยาว
            </>
          )}
        </p>
      </div>
      <div className="solution-card">
        <div className="icon-container">
          <IoMdCloudOutline className="icon" alt="Cloud Icon" />
        </div>
        <h3>
          {language === "en"
            ? "Cloud Solution"
            : "โซลูชันคลาวด์ (Cloud Solution)"}
        </h3>
        <p>
          {language === "en" ? (
            <>
              At Proscope, we believe that cloud technology doesn’t aim to
              replace all existing systems, but rather to complement and enhance
              them. In most cases, a hybrid IT model—combining cloud services
              with on-premise infrastructure—delivers the flexibility businesses
              need today.
              <br />
              <br />
              Mission-critical operations may still rely on traditional systems,
              but cloud is ideal for scalable, cost-efficient, and
              fast-deployable services. We focus on delivering tailored SaaS
              solutions and cloud platforms that grow with our customers’ needs,
              ensuring a smooth and secure digital transformation journey.
            </>
          ) : (
            <>
              ที่ Proscope เราเชื่อว่าคลาวด์ไม่ได้เข้ามาแทนที่ทุกระบบเดิม
              แต่เข้ามาเติมเต็มและยกระดับโครงสร้างพื้นฐานที่มีอยู่
              โดยเฉพาะรูปแบบ Hybrid IT ที่ผสานคลาวด์เข้ากับระบบ On-premise
              ซึ่งตอบโจทย์ความยืดหยุ่นในยุคปัจจุบันได้อย่างลงตัว
              <br />
              <br />
              แม้ระบบภารกิจสำคัญยังคงใช้โครงสร้างเดิม
              แต่คลาวด์เหมาะสำหรับบริการที่ต้องการความยืดหยุ่น ประหยัด
              และรวดเร็วในการใช้งาน เรามุ่งเน้นการส่งมอบโซลูชัน SaaS
              และแพลตฟอร์มคลาวด์ที่ปลอดภัยและปรับตามการเติบโตของธุรกิจได้
            </>
          )}
        </p>
      </div>

      <div className="solution-card">
        <div className="icon-container">
          <BsRocketTakeoff alt="Enterprise Icon" className="icon" />
        </div>
        <h3>
          {language === "en"
            ? "Value Added Distributor"
            : "ตัวแทนจำหน่าย (Value-Added Distributor)"}
        </h3>
        <p>
          {language === "en" ? (
            <>
              Proscope acts as a value-added distributor of hardware, software,
              and specialized applications, helping partners expand into the
              Thai market with confidence. We dedicate our engineering and sales
              teams to each solution to ensure optimized delivery, customer
              satisfaction, and technical excellence.
              <br />
              <br />
              With strong vendor relationships and deep market knowledge, we
              accelerate product adoption and maximize service quality. Our
              commitment is to offer technical guidance and go-to-market support
              that strengthens the presence and performance of our
              partners—turning technology into business growth opportunities.
            </>
          ) : (
            <>
              Proscope ทำหน้าที่เป็นผู้จัดจำหน่ายแบบเพิ่มมูลค่า (VAD)
              สำหรับสินค้าไอที ซอฟต์แวร์ และโซลูชันเฉพาะทางในตลาดประเทศไทย
              เราจัดสรรทรัพยากรทีมวิศวกรและฝ่ายขายเฉพาะผลิตภัณฑ์
              เพื่อให้มั่นใจว่าการสนับสนุนมีประสิทธิภาพและตรงจุด
              <br />
              <br />
              ด้วยประสบการณ์ในตลาดและความสัมพันธ์ที่ดีกับ Vendor ชั้นนำ
              เราช่วยให้พันธมิตรเข้าสู่ตลาดได้รวดเร็ว สนับสนุนการใช้งาน
              และสร้างโอกาสทางธุรกิจอย่างยั่งยืนในยุคที่เทคโนโลยีเปลี่ยนแปลงอย่างรวดเร็ว
            </>
          )}
        </p>
      </div>

      <div className="solution-card">
        <div className="icon-container">
          <img src={maintenance} alt="Distributor Icon" className="icon" />
        </div>
        <h3>
          {language === "en"
            ? "Maintenance Services"
            : "บริการบำรุงรักษาระบบ (Maintenance Services)"}
        </h3>{" "}
        <p>
          {language === "en" ? (
            <>
              Proscope provides tailored maintenance services to ensure your IT
              systems remain stable, secure, and high-performing. We offer
              comprehensive packages that include preventive maintenance,
              software updates, system monitoring, and rapid issue
              resolution—both remotely and on-site.
              <br />
              <br />
              Our certified engineers deliver proactive support that minimizes
              downtime and maximizes uptime. With flexible service-level
              agreements (SLAs), we align our support with your operational
              priorities and business goals.
              <br />
              <br />
              Whether you're maintaining critical infrastructure or user
              endpoints, our service model ensures continuity and peace of mind—
              <strong>
                allowing you to focus on your core business, innovation, and
                growth while we take care of the technology behind it.
              </strong>
            </>
          ) : (
            <>
              Proscope ให้บริการบำรุงรักษาระบบไอทีแบบครบวงจร
              เพื่อให้โครงสร้างพื้นฐานของคุณทำงานได้อย่างมีเสถียรภาพ ปลอดภัย
              และมีประสิทธิภาพสูงสุด เราให้บริการทั้งการตรวจสอบเชิงป้องกัน
              อัปเดตซอฟต์แวร์ การมอนิเตอร์ระบบ และการแก้ไขปัญหาอย่างรวดเร็ว
              ทั้งแบบรีโมตและเข้าไซต์งาน
              <br />
              <br />
              ทีมวิศวกรมืออาชีพของเราพร้อมให้การสนับสนุนเชิงรุกเพื่อลดเวลา
              Downtime และเพิ่มความต่อเนื่องในการดำเนินงาน ด้วยสัญญาการให้บริการ
              (SLA) ที่ยืดหยุ่น
              เราจึงสามารถปรับให้เข้ากับความต้องการของแต่ละองค์กรได้อย่างลงตัว
              <br />
              <br />
              <strong>
                เพื่อให้คุณสามารถโฟกัสกับธุรกิจหลัก นวัตกรรม
                และการเติบโตขององค์กรได้อย่างเต็มที่ —
                ปล่อยให้เรื่องเทคโนโลยีเป็นหน้าที่ของเรา
              </strong>
            </>
          )}
        </p>
      </div>
    </section>
  );
};

export default Solutions;
